import { useEffect } from 'react';

import { Stripe } from '@stripe/stripe-js';

export const useStripeLoadMonitor = (
  stripePromise: Promise<Stripe | null>,
  onFailedToLoadStripe?: () => void,
) => {
  useEffect(() => {
    let isMounted = true;

    stripePromise.catch(() => {
      if (isMounted) {
        onFailedToLoadStripe?.();
      }
    });

    return () => {
      isMounted = false;
    };
  }, [stripePromise, onFailedToLoadStripe]);
};
